"use client";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { useGSAP } from "@gsap/react";

/**
 * Single registration point for every GSAP plugin + the site's easing vocabulary.
 *
 *  premium — strong ease-out for UI entrances (cubic-bezier(.23,1,.32,1))
 *  silk    — long expo-like settle for editorial reveals and product mockups
 *  glide   — in-out for elements travelling across the screen
 *  drift   — near-linear for scrubbed, scroll-linked motion
 */
let registered = false;

function register() {
  if (registered || typeof window === "undefined") return;
  gsap.registerPlugin(ScrollTrigger, CustomEase, useGSAP);

  CustomEase.create("premium", "0.23, 1, 0.32, 1");
  CustomEase.create("silk", "0.16, 1, 0.3, 1");
  CustomEase.create("glide", "0.77, 0, 0.175, 1");
  CustomEase.create("drift", "0.33, 0, 0.67, 1");

  gsap.defaults({ ease: "premium", duration: 1 });
  ScrollTrigger.config({ ignoreMobileResize: true });
  registered = true;
}

register();

/**
 * One-shot reveals use `toggleActions: PLAY_ONCE`, never `once: true`. Both play on enter and
 * never reverse, but `once` makes a trigger kill itself the moment it is passed. When the page
 * mounts already scrolled past several reveals (Back to a restored position, a scroll before
 * hydration, a hot reload mid-page), those kills land inside another trigger's refresh, the
 * trigger list shrinks under GSAP's loop, and it throws "Cannot read properties of undefined
 * (reading 'end')" — which takes the whole page down. A trigger that stays alive can't do that.
 */
export const PLAY_ONCE = "play none none none";

export { gsap, ScrollTrigger, CustomEase, useGSAP };
